/**
 * StatusPanelItem — Linha individual no painel de notificações
 */
import React from 'react';
import type { NotificationItem } from '../../stores/bigwaStatusPanelStore';

const STATUS_COLORS: Record<string, string> = {
  success: '#477B72',
  error: '#D4918A',
  pending: '#F2BC41',
  info: '#DADADA',
};

interface Props {
  item: NotificationItem;
}

export const StatusPanelItem = React.memo<Props>(function StatusPanelItem({ item }) {
  return (
    <div className="bsp__item">
      <span
        className={`bsp__dot ${item.status === 'pending' ? 'bsp__dot--pulse' : ''}`}
        style={{ backgroundColor: STATUS_COLORS[item.status] || '#DADADA' }}
      />
      <span className="bsp__item-text">{item.message}</span>
      {item.action && (
        <button
          className="bsp__item-action"
          onClick={item.action.onClick}
        >
          {item.action.label}
        </button>
      )}
    </div>
  );
});
